<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <tt-list [ttData]="itemsListStockOnLocations"></tt-list>
    </div>

    <div class="col-xs-12 sp-0 height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="col-xs-12 p-5 flex-1 height-full" [(ttOptions)]="grid"></tt-grid>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="prod_id" [ttModel]="setting.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="setting.prod_name" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto [ttText]="'stockonlocation_goto_stockget'" [ttGoto]="'stockget'" [ttGotoParms]="{ stock_keyno: setting.stock_keyno }"></tt-button-goto>
    </ng-container>
</ng-template>
